import BaseComponent from '../base-component/base-component'
import Carousel from '../carousel/carousel'
import { Nullable } from '../../types/common'

class DeferredMedia extends BaseComponent {
  poster: Nullable<HTMLElement>

  constructor() {
    super()

    this.poster = this.querySelector('[id^="Deferred-Poster-"]')
  }

  connectedCallback(): void {
    if (this.hasAttribute('data-autoplay')) {
      this.loadContent()
    }

    this.poster.addEventListener('click', this.handlePosterClick)

    if (this.carousel) {
      this.carousel.embla.on('select', this.handleCarouselSelect)
    }
  }

  disconnectedCallback(): void {
    this.poster.removeEventListener('click', this.handlePosterClick)

    if (this.carousel) {
      this.carousel.embla.off('select', this.handleCarouselSelect)
    }
  }

  handleCarouselSelect = (): void => {
    this.removeVideo()
  }

  handlePosterClick = (): void => {
    this.loadContent()
  }

  loadContent(): void {
    if (!this.getAttribute('loaded')) {
      this.addVideo()

      this.setAttribute('loaded', 'true')
    }
  }

  removeVideo(): void {
    const video = this.querySelector('video,  iframe')

    if (video) {
      video.remove()

      this.removeAttribute('loaded')
    }
  }

  addVideo(): void {
    const content = document.createElement('div')
    const template = this.querySelector('template')
    const templateContent = template?.content

    if (!templateContent || !templateContent.firstElementChild) {
      return
    }

    const firstChild = templateContent.firstElementChild.cloneNode(true)

    content.appendChild(firstChild)
    const video = content.querySelector<any>('video, model-viewer, iframe')

    if (!video) {
      return
    }

    this.appendChild(video)

    if (video.tagName === 'VIDEO') {
      video.play()
    }
  }

  get carousel() {
    return this.closest<Carousel>('carousel-component')
  }
}

export default DeferredMedia
